// extracted by mini-css-extract-plugin
export default {"cancelLink":"qR-z"};